import React from 'react'

const Footer = () => {
  return (
    <div className='flex flex-col-reverse md:flex-row justify-between px-8 py-10 md:py-16 border-t border-[#eaecf0] text-[#667085] text-[14px] bg-[#fafafa]'>
        <p>© 2025 Leafwell Farm Real Estate NY, LLC. All rights reserved.</p>
        <div className='space-x-4 mb-4 md:mb-0'>
            <a href="/terms-of-service">Terms</a>
            <a href="/terms-of-service">Privacy</a>
        </div>
    </div>
  )
}

export default Footer
